import { useEffect, useRef, useState } from "react";
import { useInView, animate, motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";
import { STATS } from "./data";

const Counter = ({ to }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.3 });
  const [val, setVal] = useState(to);
  useEffect(() => {
    if (!inView) return undefined;
    const c = animate(0, to, { duration: 2, ease: "easeOut", onUpdate: (v) => setVal(Math.round(v)) });
    return () => c.stop();
  }, [inView, to]);
  return <span ref={ref}>{val}</span>;
};

export const Covid = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <section id="covid" ref={ref} data-testid="covid-section" className="relative bg-[#FAF7F2] py-24 lg:py-36">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-10 lg:gap-14">
        <Reveal className="lg:col-span-4 order-2 lg:order-1">
          <div className="relative h-[420px] lg:h-full lg:min-h-[640px] rounded-[28px] overflow-hidden">
            <motion.img style={{ y }} src="/images/p10.jpg" alt="Wings of Fire Foundation community event" className="absolute inset-0 w-full h-[116%] -top-[8%] object-cover" />
          </div>
        </Reveal>
        <div className="lg:col-span-8 order-1 lg:order-2">
          <Eyebrow testId="covid-eyebrow">Our COVID-19 Response</Eyebrow>
          <Reveal>
            <h2 className="font-serif text-5xl sm:text-6xl text-[#0F1D2F] mt-6 leading-[0.95] tracking-tight">
              Serving Our Communities During <em className="text-fire">Unprecedented Times</em>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 text-base sm:text-lg text-[#2B3A4A] leading-relaxed max-w-2xl">
              Wings of Fire Foundation goes beyond our scope of work to respond to any disasters in the city, especially those that impact our communities. COVID-19 has drastically changed all of our lives but during the lockdowns in India in 2020 and 2021, it impacted the poor the most. During this time, WOFF led efforts in Telangana providing immediate relief to families and children with disabilities.
            </p>
          </Reveal>
          <div data-testid="covid-stats-grid" className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {STATS.map((s, i) => (
              <Reveal key={s.label} delay={i * 0.08} className="h-full">
                <div data-testid={`covid-stat-${i}`} className="h-full rounded-[24px] bg-[#4B6962] text-white p-7 flex flex-col justify-between min-h-[190px] hover:bg-[#3D5A53] transition-colors">
                  <p className="font-serif text-5xl sm:text-6xl leading-none text-[#FBE3C8]">
                    {s.value !== null ? <Counter to={s.value} /> : "24/7"}
                  </p>
                  <div className="mt-6">
                    <p className="font-semibold text-lg">{s.label}</p>
                    <p className="text-sm text-[#E1EAE6] mt-1">{s.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
